export const LOADING_GIF = 'https://dev.ptcg.app/images/loading.gif'

export function Loading({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="loading-screen" aria-live="polite" aria-busy="true">
      <img className="loading-gif" src={LOADING_GIF} alt={label} />
    </div>
  )
}

